import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-passwordrecovery',
  templateUrl: './passwordrecovery.component.html',
  styleUrls: ['./passwordrecovery.component.css']
})
export class PasswordrecoveryComponent implements OnInit {

  getLanguage():string{
    if (localStorage){
        return localStorage['language'] || "";
    }
    else{
        return "";
    }
}

setLanguage(language: string){
  if (localStorage){
      localStorage['language'] = language;
  }
}

  constructor(private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private _snackBar: MatSnackBar, private route: ActivatedRoute, private router:Router) {

    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

   }

   secret:string;
   token:string;
   showError:boolean = false;
   loading:boolean = false;
   hide:boolean = true;

   RepeatPassword:string;
   Password:string;

   User:any;

  ngOnInit(): void {
    this.getParamValuesAndData();
  }

  getParamValuesAndData() {
    this.route.queryParams.subscribe(params => {   
      
      if(params['secret']){
        this.secret = params['secret'];
      }

      if(params['token']){
        this.token = params['token'];
      }
        
      if(this.secret != undefined && this.secret != null && this.token != undefined && this.token != null){
        this.ProcessPasswordRecoveryUrlData();
      }
      else{
        this.showError = true;
      }
    });
  }

  openSnackBar(message: string, action: string, designClass: string) {
    this._snackBar.open(message, action, {
      duration: 500000,
      panelClass: [designClass]
    });
  }

  ProcessPasswordRecoveryUrlData(){
    var request = {
      Language:this.getLanguage(),
      Secret:this.secret,
      Token:this.token,
    };
  
    this.loading = true;
  
    this.service.ProcessPasswordRecoveryUrlData(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        this.showError = true;
      }
      else if(response["Status"] == 1){
        this.User = response["User"];
      }
  
      this.loading = false;
    });
  } 

  ChangeUserPassword(){
    var request = {
      Language:this.getLanguage(),
      NewPassword:this.Password,
      ConfirmNewPassword:this.RepeatPassword,
      User:this.User,
      NoSecurity:true
    };
  
    this.loading = true;
  
    this.service.ChangeUserPassword(request).subscribe(response => {
   
      if(response["Status"] == -1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
  
      this.loading = false;
    });
  } 

}
